var e = {
	members: {
		title: "Workspace Members",
		subtitle: "Manage your team members.",
		tabs: {
			members: "Members",
			invites: "Pending invites"
		},
		inviteMember: "Invite Member",
		search: "Search members...",
		allRoles: "All roles",
		filters: "Filters",
		moreFilters: "More Filters",
		moreFiltersComingSoon: "Additional member filters coming soon.",
		empty: "No members found.",
		roleOwner: "Owner",
		roleMember: "Member",
		roleMore: "+{{count}} more",
		columns: {
			name: "Name",
			role: "Role",
			joined: "Joined"
		},
		actions: {
			title: "Member actions",
			editPermissions: "Edit Permissions",
			removeMember: "Remove Member",
			editPermissionsTooltip: "Edit permissions",
			removeSelectedTooltip: "Remove selected"
		},
		remove: {
			confirm: "Remove {{name}} from this workspace?",
			success: "Removed {{name}}",
			error: "Failed to remove member"
		},
		rowActions: "Actions for {{name}}"
	},
	memberPermissions: {
		title: "Edit Permissions",
		titleWithName: "Edit Permissions · {{name}}",
		atLeastOne: "Select at least one permission",
		updated: "Permissions updated",
		updateError: "Failed to update permissions",
		save: "Save Changes"
	},
	invite: {
		title: "Invite to {{workspace}}",
		intro: "Invite team members to co-manage properties in your workspace.",
		emailLabel: "Email address",
		emailPlaceholder: "colleague@example.com",
		emailInvalid: "Enter a valid email address",
		assignRole: "Assign Role (optional)",
		noRole: "No role",
		roleOption: "{{name}} ({{count}} permissions)",
		extraPermissions: "Extra Permissions (optional)",
		extraPermissionsHint: "Grant additional permissions beyond the selected role.",
		send: "Send Invitation",
		success: "Invitation sent to {{email}}",
		error: "Failed to send invitation",
		noWorkspace: {
			title: "No workspace found",
			description: "You need to create a workspace before you can invite team members."
		}
	},
	invites: {
		empty: "No pending invitations.",
		statusPending: "Pending",
		columns: {
			email: "Email",
			status: "Status",
			sent: "Sent",
			expires: "Expires"
		}
	},
	roles: {
		title: "Workspace Roles",
		subtitle: "Manage roles with custom permissions for your workspace members.",
		create: "Create Role",
		empty: "No roles found. Create one to get started.",
		view: "View",
		deleted: "Role deleted",
		deleteError: "Failed to delete role",
		delete: {
			title: "Delete role?",
			message: "Members assigned to “{{name}}” will lose the permissions it grants. This cannot be undone.",
			action: "Delete {{name}}"
		},
		columns: {
			name: "Name",
			description: "Description",
			users: "Users",
			assignedAt: "Assigned At",
			type: "Type"
		},
		noDescription: "—",
		createPage: {
			title: "Create Role",
			intro: "Define a new role with custom permissions for your workspace.",
			nameLabel: "Role Name",
			namePlaceholder: "e.g. Property Manager",
			descriptionLabel: "Description",
			descriptionPlaceholder: "Optional description",
			permissions: "Permissions",
			submit: "Create Role",
			success: "Role created successfully",
			error: "Failed to create role"
		},
		edit: {
			title: "Edit Role",
			intro: "Modify name, description, and permissions for this role.",
			warningTitle: "Warning: Impact on existing users",
			warningBody_one: "Updating permissions for this role will immediately grant or revoke these permissions for the {{count}} user currently assigned to it.",
			warningBody_other: "Updating permissions for this role will immediately grant or revoke these permissions for all {{count}} users currently assigned to it.",
			nameLabel: "Role Name",
			namePlaceholder: "e.g. Content Manager",
			descriptionLabel: "Description (Optional)",
			descriptionPlaceholder: "Briefly describe what this role can do",
			permissions: "Permissions",
			permissionsHint: "Select the permissions to grant to this role. Some view permissions are required depending on the actions selected.",
			submit: "Save Changes",
			success: "Role updated successfully",
			error: "Failed to update role"
		},
		validation: {
			nameRequired: "Name is required",
			atLeastOnePermission: "Select at least one permission"
		},
		notFound: "Role not found",
		backToRoles: "Back to Roles",
		details: {
			loading: "Loading role...",
			noDescription: "No description provided.",
			editRole: "Edit Role",
			assignedUsers: "Assigned Users",
			assignedCount_one: "{{count}} user assigned to this role.",
			assignedCount_other: "{{count}} users assigned to this role.",
			empty: "No users are currently assigned to this role.",
			unknownUser: "Unknown User",
			noPermissions: "This role grants no permissions.",
			permissions: "Permissions"
		},
		assign: {
			assignUser: "Assign User",
			title: "Assign Role",
			description: "Search and select members to assign to {{role}}.",
			allAssigned: "All workspace members already hold this role.",
			searchPlaceholder: "Search by name or email...",
			selectLabel: "Select members",
			atLeastOne: "Select at least one member",
			submit: "Assign",
			success_one: "{{count}} user assigned successfully!",
			success_other: "{{count}} users assigned successfully!",
			error: "Failed to assign role",
			appliesOnNextSignIn: "Changes take effect immediately here. Elsewhere in the app they apply the next time the member signs in.",
			addsRole: "Assigning adds this role to the member; it does not replace a role they already have."
		},
		badge: {
			predefined: "Predefined",
			custom: "Custom"
		},
		predefined: {
			title: "Predefined role",
			body: "This role is provided by MAAT and kept up to date for you. It cannot be edited or deleted — duplicate it to make your own version."
		},
		duplicate: {
			action: "Duplicate",
			copyName: "{{name}} (copy)",
			success: "Role duplicated — you can edit the copy now",
			error: "Failed to duplicate role"
		},
		propertyScoped: {
			title: "This role is usually limited to specific properties",
			body: "Permissions alone give access across the whole workspace. Assign {{name}} to the properties they should cover."
		}
	},
	settings: {
		heading: "Workspace",
		sections: {
			general: {
				label: "General",
				description: "Workspace name, type, and basics."
			},
			verification: {
				label: "Workspace Verification",
				description: "Verify your business / individual workspace."
			},
			billing: {
				label: "Billing",
				description: "Plan, invoices, and payment details."
			},
			notifications: {
				label: "Notifications",
				description: "What this workspace gets told about."
			},
			integrations: {
				label: "Integrations",
				description: "Connect the tools you already use."
			},
			operations: {
				label: "Operations",
				description: "Housekeeping rules for your rooms."
			}
		},
		placeholderComingSoon: "Coming soon.",
		general: {
			title: "General",
			description: "Workspace name, type, and basics."
		},
		about: {
			title: "About",
			description: "Shown to guests on your public host profile.",
			bioLabel: "Bio",
			bioPlaceholder: "Tell guests a little about yourself and your hosting style…",
			bioMax: "Keep your bio under 600 characters",
			languagesLabel: "Languages you speak",
			languagesPlaceholder: "Select languages",
			saving: "Saving…",
			updated: "Profile updated",
			updateError: "Failed to update profile"
		},
		logo: {
			title: "Workspace logo",
			description: "Shown to guests in chat and across your listings.",
			uploading: "Uploading…",
			upload: "Upload logo",
			hint: "JPG, PNG or WebP — up to 5 MB.",
			unsupportedType: "Choose a JPG, PNG or WebP image.",
			updated: "Logo updated",
			uploadError: "Failed to upload logo"
		},
		billing: {
			title: "Billing",
			description: "Invoice details for this workspace.",
			noAccess: "You don't have access to this workspace's billing details.",
			cardTitle: "Billing details",
			cardDescription: "Appears on invoices issued for this workspace.",
			businessNameLabel: "Legal business name",
			businessNamePlaceholder: "e.g. Acme Stays LLC",
			taxIdLabel: "Tax / VAT number",
			taxIdPlaceholder: "Tax / VAT number",
			registrationLabel: "Registration number",
			registrationPlaceholder: "Commercial registration no.",
			billingEmailLabel: "Billing email",
			billingEmailPlaceholder: "invoices@example.com",
			billingEmailInvalid: "Enter a valid email address",
			phoneLabel: "Phone",
			phonePlaceholder: "Phone number",
			countryLabel: "Country",
			countryPlaceholder: "Country",
			stateLabel: "State / Province",
			statePlaceholder: "State",
			cityLabel: "City",
			cityPlaceholder: "City",
			streetLabel: "Address line",
			streetPlaceholder: "Street address",
			buildingLabel: "Building",
			buildingPlaceholder: "Building",
			postalCodeLabel: "Postal code",
			postalCodePlaceholder: "Postal code",
			save: "Save billing details",
			saved: "Billing details saved",
			saveError: "Failed to save billing details"
		},
		integrations: {
			title: "Integrations",
			description: "Connect this workspace to the tools you already use.",
			noAccess: "You don't have access to this workspace's integrations.",
			pricelabs: {
				title: "PriceLabs",
				description: "Revenue management. PriceLabs sets your nightly rates and minimum stays from live market demand, and pushes them straight into your calendar.",
				ownAccountNote: "You'll need your own PriceLabs account — PriceLabs bills you directly for their service. There's no API key to copy: your account email is all we need.",
				emailLabel: "PriceLabs account email",
				emailPlaceholder: "you@example.com",
				emailHint: "The email address your PriceLabs account is registered with. It's how PriceLabs recognises which account your listings belong to.",
				emailInvalid: "Enter the email address your PriceLabs account uses.",
				connect: "Connect PriceLabs",
				connected: "PriceLabs connected",
				connectError: "We couldn't connect PriceLabs. Please try again.",
				alreadyConnected: "This workspace is already connected to PriceLabs. Refresh to see the current connection.",
				statusConnected: "Connected",
				account: "Linked to {{email}}",
				connectedSince: "Connected {{date}}",
				enabledListings_one: "{{count}} listing is using PriceLabs pricing",
				enabledListings_other: "{{count}} listings are using PriceLabs pricing",
				lastRatePush: "Rates last received {{date}}",
				noRatesYet: "No rates received yet — turn the listing's sync on in your PriceLabs dashboard to start.",
				disconnect: "Disconnect",
				disconnectConfirmTitle: "Disconnect PriceLabs?",
				disconnectConfirmBody: "Every listing in this workspace will stop using PriceLabs pricing and go back to your base rate. Pricing rules that PriceLabs switched off are not turned back on — you'll re-enable the ones you still want. Reconnecting later starts fresh: you'll enter your email again and opt each listing back in.",
				disconnected_one: "PriceLabs disconnected — {{count}} listing switched back to your own pricing.",
				disconnected_other: "PriceLabs disconnected — {{count}} listings switched back to your own pricing.",
				disconnectError: "We couldn't disconnect PriceLabs. Please try again.",
				unavailableTitle: "Not available on this environment",
				unavailableBody: "The PriceLabs integration isn't configured here yet, so there's nothing to connect to. Nothing about your listings has changed.",
				unreadableTitle: "We couldn't load your PriceLabs connection",
				unreadableBody: "This doesn't mean it's disconnected — we just couldn't read it.",
				retry: "Try again",
				notConnectedTitle: "PriceLabs isn't connected",
				notConnectedNoPermission: "Someone with permission to manage pricing can connect this workspace's PriceLabs account."
			}
		},
		verification: {
			title: "Workspace Verification",
			description: "Verify your workspace to operate as a business.",
			individualNotice: "This is an individual workspace — it's verified through the owner's personal identity, not a business (KYB) flow.",
			goToIdentity: "Go to Identity Verification",
			status: {
				title: "Verification status",
				description: "Verify your business to operate as a legal entity.",
				submitted: "Submitted {{date}}",
				reviewed: "Reviewed {{date}}"
			},
			details: {
				title: "Business details",
				description: "Enter your legal business details exactly as they appear on your registration.",
				legalNameLabel: "Legal business name",
				legalNamePlaceholder: "e.g. Acme Stays LLC",
				registrationLabel: "Registration number",
				registrationPlaceholder: "Commercial registration no.",
				taxIdLabel: "Tax ID",
				taxIdPlaceholder: "TIN / tax card number",
				incorporationDateLabel: "Incorporation date",
				addressLabel: "Business address",
				addressPlaceholder: "Registered address",
				submitting: "Submitting…",
				submit: "Submit for review",
				submitted: "Submitted for review",
				submitError: "Failed to submit verification",
				validation: {
					legalName: "Enter your legal business name",
					registration: "Enter your registration number",
					taxId: "Enter your tax ID",
					address: "Enter your business address",
					incorporationDate: "Select the incorporation date"
				}
			},
			documents: {
				title: "Documents",
				description: "Upload clear scans of your company documents. They are stored privately.",
				tapToUpload: "Tap to upload an image or PDF",
				uploading: "Uploading {{label}}…",
				uploaded: "{{label}} uploaded",
				uploadError: "Failed to upload {{label}}",
				removed: "{{label}} removed",
				removeError: "Failed to remove {{label}}",
				removalRequested: "Removal requested for {{label}}",
				removalRequestError: "Failed to request removal of {{label}}",
				removalCancelled: "Removal request for {{label}} cancelled",
				removalCancelError: "Failed to cancel removal of {{label}}",
				pendingRemoval: "Pending Removal",
				cancelRequest: "Cancel request",
				requestRemoval: "Request removal",
				remove: "Remove",
				fallbackFilename: "Document",
				rejected: "Rejected — {{reason}}",
				removalDeclined: "Removal declined — {{reason}}"
			}
		}
	},
	permissionPicker: {
		required: "Required",
		groups: {
			properties: "Properties",
			experiences: "Experiences",
			services: "Services",
			bookings: "Bookings",
			reservations: "Reservations",
			finance: "Finance",
			workspace: "Workspace",
			pricing: "Pricing",
			bookingRules: "Booking Rules",
			calendar: "Calendar",
			travelGuides: "Travel Guides",
			coupons: "Coupons",
			chat: "Messaging",
			automatedMessages: "Automated Messages",
			pbac: "Property Access",
			verification: "Verification",
			guestDocuments: "Guest ID Documents",
			developer: "Developer Access",
			frontDesk: "Front desk & housekeeping",
			reports: "Reports"
		}
	},
	accept: {
		loading: "Validating your invitation...",
		invalid: {
			title: "Invitation Unavailable",
			goHome: "Go to Home",
			noLongerValid: "This invitation is no longer valid.",
			noToken: "No invitation token provided.",
			revoked: "This invitation is invalid or has been revoked.",
			alreadyUsed: "This invitation has already been used.",
			expired: "This invitation has expired. Please ask the workspace owner to send a new one."
		},
		step: {
			title: "You're Invited!",
			body: "You've been invited to join {{workspace}} as {{email}}.",
			accept: "Accept Invitation",
			decline: "Decline",
			welcome: "Welcome to {{workspace}}!",
			acceptError: "Failed to accept invitation"
		},
		fallbackWorkspace: "Workspace",
		login: {
			title: "Welcome Back",
			subtitle: "Sign in with {{email}} to accept your invitation.",
			action: "Log in or sign up"
		},
		register: {
			confirmTitle: "Create Your Account",
			confirmBody: "We'll send a 6-digit verification code to",
			sendCode: "Send Verification Code",
			sendError: "Failed to send verification code.",
			verifyTitle: "Verify Your Email",
			completeTitle: "Complete Your Profile",
			verifySubtitle: "Enter the code sent to {{email}}",
			completeSubtitle: "Set up your name and password to finish"
		}
	}
};
//#endregion
export { e as default };
